import { render } from "./BuypassSettingsInfoModal.vue?vue&type=template&id=2e35034e"
import script from "./BuypassSettingsInfoModal.vue?vue&type=script&lang=js"
export * from "./BuypassSettingsInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__